import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import instance from "../../../config/Config";

const initialState = {
  loading: false,
  response: null,
  error: null,
};

// PAYMENT LINKJ GENERATE-
export const registerRemarkUser = createAsyncThunk(
  "registerRemarkUser",
  async (data, { rejectWithValue }) => {
    try {

      const response = instance.post("crm/users/user-register", data);

      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);


export const remarkUserSlice = createSlice({
  name: "remarkUserSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(registerRemarkUser.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(registerRemarkUser.fulfilled, (state, action) => {

      state.loading = false;
      state.response = action?.payload?.data;
    });
    builder.addCase(registerRemarkUser.rejected, (state, action) => {
      state.loading = false;
    });






  

  },
});
export default remarkUserSlice.reducer;
